import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getTaxList, getUnitWeightList, getUnitSizeList, getUnitSaleList, updatePriceAndStock, getPriceAndStockInfo, getSpecList as _getSpecList, addSpecValue as _addSpecValue, updateSpecValue as _updateSpecValue, deleteSpecValue as _deleteSpecValue, getSpecValueDetail, updateSpecName as _updateSpecName, getSpecNameDetail, saveSpecDetailList, getSpecDetailList as _getSpecDetailList, getTransport, getFrightMode, updateSpecSort, getContentfromProductNO, getBrand, getSourcearea } from '@/services/productDetail';
import { getPaymentDropdownList } from '@/services/systemsetting';
import { getMerchantChannelList } from '@/services/labelingManagement.js';
import editableCell from '@/pages/productmanager/components/editableCellInput.vue';
import editableCellSelect from '@/pages/productmanager/components/editableCellSelect.vue';
import editableCellNum from '@/pages/productmanager/components/editableCellInputNum.vue';
import bundlingModal from './bundlingModal.vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import Sortable from 'sortablejs';
import moment from 'moment';
export default {
  name: 'priceStock',
  i18n: require('../i18n-productDetail'),
  components: {
    editableCell: editableCell,
    editableCellSelect: editableCellSelect,
    FooterToolBar: FooterToolBar,
    editableCellNum: editableCellNum,
    bundlingModal: bundlingModal
  },
  props: ['productId', 'specFlag'],
  data: function data() {
    var _this2 = this;
    /* 规格明细列 */
    var productSpecsColumns = [
    // 规格名称
    {
      dataIndex: 'specName1',
      width: 100,
      // align: 'left', 
      key: 'specName1',
      slots: {
        title: 'specName1Title'
      },
      scopedSlots: {
        customRender: 'specName1'
      },
      fixed: 'left'
    },
    // 商品编号
    {
      dataIndex: 'productNo',
      width: 150,
      // align: 'left',
      key: 'productNo',
      slots: {
        title: 'productNoTitle'
      },
      scopedSlots: {
        customRender: 'productNo'
      },
      fixed: 'left'
    }, {
      dataIndex: 'productStocknum',
      width: '100px',
      key: 'productStocknum',
      slots: {
        title: 'productStocknumTitle'
      },
      scopedSlots: {
        customRender: 'productStocknum'
      }
    }, {
      dataIndex: 'stockSyn',
      width: '130px',
      key: 'stockSyn',
      slots: {
        title: 'stockSynTitle'
      },
      scopedSlots: {
        customRender: 'stockSyn'
      }
    },
    // 售卖方式
    {
      dataIndex: 'caseOrItem',
      width: '220px',
      key: 'caseOrItem',
      slots: {
        title: 'caseOrItemTitle'
      },
      scopedSlots: {
        customRender: 'caseOrItem'
      }
    },
    //   原产地
    {
      dataIndex: 'productSourceareaid',
      width: '150px',
      key: 'productSourceareaid',
      title: this.$t('productDetail.sourceArea'),
      scopedSlots: {
        customRender: 'productSourceareaid'
      }
    },
    //   品牌
    {
      dataIndex: 'productBrandid',
      width: '150px',
      key: 'productBrandid',
      title: this.$t('productDetail.brand'),
      scopedSlots: {
        customRender: 'productBrandid'
      }
    },
    //   容量
    {
      dataIndex: 'capacity',
      width: '120px',
      align: 'left',
      key: 'capacity',
      slots: {
        title: 'capacityTitle'
      },
      scopedSlots: {
        customRender: 'capacity'
      }
    },
    // 最小起订量
    {
      dataIndex: 'minOrderQuantity',
      width: '150px',
      key: 'minOrderQuantity',
      slots: {
        title: 'minOrderQuantityTitle'
      },
      scopedSlots: {
        customRender: 'minOrderQuantity'
      }
    },
    // 入数
    {
      dataIndex: 'caseQuantity',
      width: '120px',
      key: 'caseQuantity',
      slots: {
        title: 'caseQuantityTitle'
      },
      scopedSlots: {
        customRender: 'caseQuantity'
      }
    },
    // jan
    {
      dataIndex: 'productBarcode',
      width: '150px',
      key: 'productBarcode',
      slots: {
        title: 'productBarcodeTitle'
      },
      scopedSlots: {
        customRender: 'productBarcode'
      }
    },
    // 建议售价
    {
      dataIndex: 'productPrice',
      width: '200px',
      align: 'left',
      key: 'productPrice',
      slots: {
        title: 'productPriceTitle'
      },
      scopedSlots: {
        customRender: 'productPrice'
      }
    },
    // 仕入类型
    {
      dataIndex: 'productBelong',
      width: '130px',
      key: 'productBelong',
      slots: {
        title: 'productBelongTitle'
      },
      scopedSlots: {
        customRender: 'productBelong'
      }
    },
    // 仕入先
    {
      dataIndex: 'supplierName',
      width: '150px',
      key: 'supplierName',
      slots: {
        title: 'supplierNameTitle'
      },
      scopedSlots: {
        customRender: 'supplierName'
      }
    }
    // { dataIndex: 'productLong', width: '100px',  key: 'productLong', slots: { title: 'productLongTitle' }, scopedSlots: { customRender: 'productLong' } },
    // {
    // 	dataIndex: 'productWidth',
    // 	width: '100px',
    // 	key: 'productWidth',
    // 	slots: { title: 'productWidthTitle' },
    // 	scopedSlots: { customRender: 'productWidth' }
    // },
    // {
    // 	dataIndex: 'productHeight',
    // 	width: '100px',
    // 	key: 'productHeight',
    // 	slots: { title: 'productHeightTitle' },
    // 	scopedSlots: { customRender: 'productHeight' }
    // },
    // {
    // 	dataIndex: 'productWeight',
    // 	width: '100px',
    // 	key: 'productWeight',
    // 	slots: { title: 'productWeightTitle' },
    // 	scopedSlots: { customRender: 'productWeight' }
    // },
    ];
    var checkSecondTransport = function checkSecondTransport(rule, value, callback) {
      if (_this2.formData.transportSecondIdList.includes(String(_this2.formData.transportFirstId)) || _this2.form2Data.transportSecondIdList.includes(String(_this2.form2Data.transportFirstId))) {
        return callback(new Error(_this2.$t('priceStock.secondTransportTips')));
      } else {
        return callback();
      }
    };
    return {
      bundlingModalVisible: false,
      // 同捆说明 visible
      bundlingNoteVisible: false,
      // 是否显示同捆输入框
      visibleSpecName: false,
      //规格名弹窗显示状态
      currentSpecNameId: '',
      //当前规格名id
      currentSpecValueId: '',
      //当前规格值id
      specsValueErrTip: this.$t('productDetail.pleaseInputSpecsValue'),
      specsNameErrTip: this.$t('productDetail.pleaseInputSpecsName'),
      updateLoadingN: false,
      //更新规格名状态loading
      addLoadingV: false,
      //保存规格值状态loading
      updateLoadingV: false,
      //更新规格值状态loading
      visibleBatch: false,
      //批量设置弹窗
      dialogStatus: '',
      //新建/修改状态位
      visibleSpecValue: false,
      //规格值弹窗显示状态
      confirmLoading: false,
      textMap: {
        //新建/修改title
        update: this.$t('productDetail.editSpecsValue'),
        create: this.$t('productDetail.addSpecsValue')
      },
      specValueData: {
        id: '',
        nameList: []
      },
      defaultLangObj: {},
      langList: [],
      initialNameList: [],
      queryLoading: false,
      queryLoading2: false,
      defaultLangName: '',
      defaultLangId: '',
      defaultExpandedRowKeys: [],
      isShow: false,
      columnsKey: [],
      stockSyncStatusList: [{
        id: 0,
        name: this.$t('public.yes'),
        status: 1
      }, {
        id: 1,
        name: this.$t('public.no'),
        status: 1
      }],
      caseOrItemList: [{
        id: '2',
        name: this.$t('newProducDetail.bulk'),
        status: 1
      }, {
        id: '1',
        name: this.$t('newProducDetail.totalBox'),
        status: 1
      }],
      productChannelidList: [],
      editproductSpecsObj: {
        productBarcode: '',
        productStocknum: '',
        productPrice: '',
        productChannelid: undefined,
        stockSyn: '1',
        productSkuno: '',
        productLength: '',
        productWidth: '',
        productHeight: '',
        productWeight: '',
        transportmoduleid: undefined
      },
      initeditproductSpecsObj: {
        productBarcode: '',
        productStocknum: '',
        productPrice: '',
        productChannelid: undefined,
        stockSyn: '1',
        productSkuno: '',
        productLength: '',
        productWidth: '',
        productHeight: '',
        productWeight: ''
      },
      modelInputStaus: '',
      //弹窗需要显示哪个

      // productSpecsList: productSpecsList2,
      columns: [],
      data: [],
      productSpecsColumns: productSpecsColumns,
      innerproductSpecsColumns: productSpecsColumns,
      productSpecsList: [],
      innerColumns: [],
      loading: false,
      memberLoading: false,
      specList: [],
      specDetailList: [],
      isTableLoading: false,
      specNameDetailData: {
        specNameDetail: []
      },
      formData: {
        id: '',
        productNo: '',
        productPrice: '',
        // 售价
        daysOfStock: "",
        //备货天数
        transportFirstId: undefined,
        //运输方式首选id
        capacity: '',
        minOrderQuantity: undefined,
        caseQuantity: "",
        productBarcode: '',
        supplierName: undefined,
        supplierCode: undefined,
        touristView: undefined,
        caseOrItem: [],
        productBelong: 1
      },
      transportList: [],
      form2Data: {
        id: '',
        daysOfStock: "",
        //备货天数
        transportFirstId: undefined //运输方式首选id
      },
      taxList: [],
      //税率列表
      paymentList: [],
      //支付方式列表
      unitSizeList: [],
      unitWeightList: [],
      sourceAreaValue: [],
      rules: {
        caseOrItem: [{
          required: true,
          message: this.$t('public.pleaseSelect'),
          trigger: 'change'
        }],
        productNo: [
        // 必填校验：失焦时触发
        {
          required: true,
          message: this.$t('public.enterPlease'),
          trigger: 'blur'
        }],
        daysOfStock: [{
          required: true,
          message: this.$t("public.enterPlease"),
          trigger: 'blur'
        }],
        transportFirstId: [{
          required: true,
          message: this.$t("publicuse.pleaseselect"),
          trigger: 'blur'
        }],
        productStocknum: [{
          required: true,
          message: this.$t("public.enterPlease"),
          trigger: 'blur'
        }]
      },
      datakey: 0,
      initForm2Data: {
        id: '',
        daysOfStock: "",
        //备货天数
        transportFirstId: undefined //运输方式首选id
      },
      //check使用
      initFormData: {
        id: '',
        productNo: '',
        productPrice: '',
        // 售价
        daysOfStock: "",
        //备货天数
        transportFirstId: undefined,
        //运输方式首选id
        capacity: '',
        minOrderQuantity: undefined,
        caseQuantity: "",
        productBarcode: '',
        supplierName: undefined,
        touristView: undefined,
        caseOrItem: []
      },
      //check使用
      initSpecDetailList: [],
      //check使用
      freightModeList: [],
      deliveryChannel: 1,
      save2Loading: false,
      errContent: '',
      erpCreateTime: '',
      visibleId: undefined,
      brandList: [],
      sourceareaList: [],
      noEditproductNo: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    if (this.deliveryChannel == 1 || this.deliveryChannel == null || this.deliveryChannel == undefined) {
      var channelObj = {
        dataIndex: 'productChannelid',
        width: '130px',
        key: 'productChannelid',
        slots: {
          title: 'productChannelidTitle'
        },
        scopedSlots: {
          customRender: 'productChannelid'
        }
      };
      this.productSpecsColumns.splice(4, 0, channelObj);
    }
    this.getInitialValue();
    this.init();
    this.inputDebounce = _.debounce(this.inputDebounce, 600);
    if (this.$route.query.vid) {
      this.visibleId = this.$route.query['vid'];
    }
  },
  methods: {
    rowDrop: function rowDrop() {
      var _this3 = this;
      this.$nextTick(function () {
        var tbody = document.querySelector("#sortDiv #sort2"); // 元素选择器名称根据实际内容替换
        console.log(tbody, 'aaaa');
        var _this = _this3;
        Sortable.create(tbody, {
          onEnd: function onEnd(_ref) {
            var _this4 = this;
            return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              var newIndex, oldIndex, data, currRow, newData, newParam, _res;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    newIndex = _ref.newIndex, oldIndex = _ref.oldIndex;
                    console.log(_this.specList[0].specValueList, currRow, 11111);
                    data = _.cloneDeep(_this.specList[0].specValueList);
                    currRow = data.splice(oldIndex, 1)[0];
                    data.splice(newIndex, 0, currRow);
                    console.log(currRow, 'newData');
                    newData = [];
                    data.forEach(function (item, index, arr) {
                      var param = {};
                      param.valueindex = index + 1;
                      param.specvalueid = item.id;
                      newData.push(param);
                    });
                    newParam = {
                      productId: _this.productId,
                      list: newData
                    };
                    console.log(newParam, 'newParams');
                    if (!(newIndex != oldIndex)) {
                      _context.n = 5;
                      break;
                    }
                    if (!_this4.updateSpecSortLoading) {
                      _context.n = 1;
                      break;
                    }
                    return _context.a(2);
                  case 1:
                    _this4.updateSpecSortLoading = true;
                    _context.p = 2;
                    _context.n = 3;
                    return updateSpecSort(newParam);
                  case 3:
                    _res = _context.v;
                    if (_res.data.code == 200) {
                      _this.getSpecList();
                      _this.getSpecDetailList();
                      _this.$message.success(_this.$t('public.updateSuccessfully'));
                    }
                  case 4:
                    _context.p = 4;
                    _this4.updateSpecSortLoading = false;
                    return _context.f(4);
                  case 5:
                    return _context.a(2);
                }
              }, _callee, null, [[2,, 4, 5]]);
            }))();
          }
        });
      });
    },
    // 清空同捆说明
    deleteBundlingNote: function deleteBundlingNote() {
      var langList = JSON.parse(localStorage.getItem('langList'));
      if (this.specFlag == 2) {
        var _iterator = _createForOfIteratorHelper(langList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var lang = _step.value;
            this.formData.bundlingNote[lang.langId] = '';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(langList),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _lang = _step2.value;
            this.form2Data.bundlingNote[_lang.langId] = '';
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    // 次选运输方式不选的时候不显示同捆说明
    handletransportSecondIdListChange: function handletransportSecondIdListChange(val) {
      console.log('va', val);
      if (val.length === 0) {
        var langList = JSON.parse(localStorage.getItem('langList'));
        if (this.specFlag == 2) {
          var _iterator3 = _createForOfIteratorHelper(langList),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var lang = _step3.value;
              this.formData.bundlingNote[lang.langId] = '';
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } else {
          var _iterator4 = _createForOfIteratorHelper(langList),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _lang2 = _step4.value;
              this.form2Data.bundlingNote[_lang2.langId] = '';
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        this.bundlingNoteVisible = false;
      } else {
        this.bundlingNoteVisible = true;
      }
      // else {

      // 	if(this.specFlag == 2) {
      // 		if(!this.formData.bundlingNote) {
      // 			this.formData.bundlingNote = {}
      // 			for(let lang of langList){
      // 				this.formData.bundlingNote[lang.langId] = ''
      // 			}
      // 		}

      // 	}else {
      // 		if(!this.form2Data.bundlingNote){
      // 			this.form2Data.bundlingNote = {}
      // 			for(let lang of langList){
      // 				this.form2Data.bundlingNote[lang.langId] = ''
      // 			}
      // 		}

      // 	}

      // }
    },
    // 处理同捆说明弹窗ok
    // handleBundlingNoteOk(value) {
    // 	console.log('value', value)
    // 	for (let item of value) {
    // 		if (this.specFlag == 2) { // 无规格
    // 			this.formData.bundlingNote[item.langId] = item.content
    // 		} else { // 有规格
    // 			this.form2Data.bundlingNote[item.langId] = item.content
    // 		}
    // 	}
    // 	this.bundlingModalVisible = false
    // },
    // 处理同捆说明弹窗cancel
    // handleBundlingNoteCancel() {
    // 	this.bundlingModalVisible = false
    // },
    getRowClass: function getRowClass(row, index) {
      console.log(row, index);
      if (row.editable) {
        return 'hideExpendIco';
      }
    },
    init: function init(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var getObj;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this5.queryLoading = true;
              if (!type) {
                //获取运输方式列表
                getTransport().then(function (response) {
                  if (response.data.code == 200) {
                    _this5.transportList = response.data.data;
                  } else {
                    _this5.$notification.error({
                      message: res.data.message
                    });
                  }
                });
                getObj = {
                  statusType: !_this5.$route.query.id ? 1 : 2
                }; // 获取品牌列表
                getBrand(getObj).then(function (res) {
                  if (res.data.code == 200) {
                    _this5.brandList = res.data.data;
                  } else {
                    _this5.$notification.error({
                      message: res.data.message
                    });
                  }
                });
                // 获取原产地列表
                getSourcearea(getObj).then(function (res) {
                  if (res.data.code == 200) {
                    _this5.sourceareaList = res.data.data;
                  } else {
                    _this5.$notification.error({
                      message: res.data.message
                    });
                  }
                });
                // 获取运费模板列表
                // getFrightMode().then(response => {
                // 	if (response.data.code == 200) {
                // 		this.freightModeList = response.data.data;
                // 		this.freightModeList = this.freightModeList.map(item => {
                // 			return {
                // 				id: item.id,
                // 				name: item.moduleName,
                // 				status: 1
                // 			}
                // 		})
                // 		console.log(this.freightModeList, '111222')
                // 	} else {
                // 		this.$notification.error({ message: res.data.message });
                // 	}
                // })
                // 税率列表
                // getTaxList().then(response => {
                // 	if (response.data.code == 200) {
                // 		this.taxList = response.data.data;
                // 	}
                // });

                //获取启用支付方式
                // getPaymentDropdownList(!this.$route.query.id ? 1 : 2).then(response => {
                // 	if (response.data.code == 200) {
                // 		this.paymentList = response.data.data;
                // 	}
                // });
                //获取启用支付方式
                // getUnitWeightList().then(response => {
                // 	if (response.data.code == 200) {
                // 		this.unitWeightList = response.data.data;
                // 	}
                // });
                //获取启用支付方式
                // getUnitSizeList().then(response => {
                // 	if (response.data.code == 200) {
                // 		this.unitSizeList = response.data.data;
                // 	}
                // });

                //获取启用发货渠道
                getMerchantChannelList({
                  statusType: !_this5.$route.query.id ? 1 : 2
                }).then(function (response) {
                  if (response.data.code == 200) {
                    _this5.productChannelidList = response.data.data;
                  }
                });
              }
              getPriceAndStockInfo(_this5.productId).then(function (response) {
                if (response.data.code == 200) {
                  var formData = response.data.data;
                  if (formData.productNo) {
                    _this5.noEditproductNo = true;
                  } else {
                    _this5.noEditproductNo = false;
                  }
                  // formData.transportmoduleid = formData.transportmoduleid == 0 ? undefined : formData.transportmoduleid
                  // if (!formData.productRate) {
                  // 	formData.productRate = undefined;
                  // }
                  // if (!formData.productWeightunit) {
                  // 	formData.productWeightunit = undefined;
                  // }
                  // if (!formData.productUnit) {
                  // 	formData.productUnit = undefined;
                  // }
                  // if (!formData.productChannelid) {
                  // 	formData.productChannelid = undefined;
                  // }
                  if (formData.productPrice == 0) {
                    formData.productPrice = '';
                  }
                  if (!formData.transportFirstId) {
                    formData.transportFirstId = undefined;
                  }
                  if (!formData.supplierName) {
                    formData.supplierName = undefined;
                  }
                  if (!formData.touristView && formData.touristView != 0) {
                    formData.touristView = undefined;
                  }
                  if (!formData.minOrderQuantity) {
                    formData.minOrderQuantity = undefined;
                  }
                  if (formData.caseOrItem && formData.caseOrItem.length > 2) {
                    formData.caseOrItem = formData.caseOrItem.split(',');
                  } else {
                    formData.caseOrItem = _toConsumableArray(formData.caseOrItem);
                  }
                  if (formData.productBrandid == 0) {
                    formData.productBrandid = undefined;
                  }
                  if (formData.productSourceareaid == 0) {
                    formData.productSourceareaid = undefined;
                  }
                  // if (formData.disabledPay) {
                  // 	formData.disabledPay = formData.disabledPay.split(',').map(Number);
                  // } else {
                  // 	formData.disabledPay = [];
                  // }
                  // if (formData.transportSecondIdList == null) {
                  // 	formData.transportSecondIdList = []
                  // }
                  // if (!formData.bundlingNote) {
                  // 	formData.bundlingNote = {}
                  // 	const langList = JSON.parse(localStorage.getItem('langList'));

                  // 	for (let lang of langList) {
                  // 		formData.bundlingNote[lang.langId] = ''
                  // 	}
                  // } else {
                  // 	formData.bundlingNote = JSON.parse(formData.bundlingNote)
                  // }
                  // if (formData.transportSecondIdList.length > 0) {

                  // 	this.bundlingNoteVisible = true
                  // }
                  // 无规格
                  if (_this5.specFlag == 2) {
                    _this5.formData = formData;
                    _this5.erpCreateTime = formData.erpCreateTime;
                    _this5.initFormData = _.cloneDeep(formData);
                  } else {
                    _this5.form2Data = formData;
                    console.log('form2data', _this5.form2Data);
                    _this5.initForm2Data = _.cloneDeep(formData);
                  }
                }
              });
              //非无规格获取规格明细列表数据
              if (!(_this5.specFlag != 2)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return _this5.getSpecList();
            case 1:
              _this5.getSpecDetailList();
            case 2:
              _this5.queryLoading = false;
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getSpecList: function getSpecList() {
      var _this6 = this;
      // 获取商品规格名和规格值列表信息（#339）
      _getSpecList(this.productId).then(function (response) {
        if (response.data.code == 200) {
          _this6.specList = response.data.data;
          _this6.rowDrop();
        }
      });
    },
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      this.defaultLangId = this.defaultLangObj.langId;

      // if (this.specFlag == 2) {
      // 	this.formData.bundlingNote = {}
      // } else { 
      // 	this.form2Data.bundlingNote = {}
      // }
      var _iterator5 = _createForOfIteratorHelper(self.langList),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          var nameObj = {};
          //标题
          nameObj.titleName = self.$t('productDetail.specsValue') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //原产地名称
          nameObj.name = '';
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }

          // if (this.specFlag == 2) {
          // 	this.formData.bundlingNote[item.langId] = ''
          // } else {
          // 	this.form2Data.bundlingNote[item.langId] = '' 
          // }
          self.initialNameList.push(nameObj);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      console.log('ok');
      self.specValueData.nameList = _.cloneDeep(self.initialNameList);
    },
    // 获取规格名详情
    getSpecName: function getSpecName(id) {
      var self = this;
      self.currentSpecNameId = id;
      getSpecNameDetail(id).then(function (response) {
        if (response.data.code == 200) {
          var dataNameList = response.data.data;
          // let newNameList = _.cloneDeep(this.initialNameList);
          var specNameDetail = [];
          var _iterator6 = _createForOfIteratorHelper(self.langList),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var item = _step6.value;
              var nameObj = {};
              //标题
              nameObj.titleName = self.$t('productDetail.specsName') + '(' + item.langName + ')';
              //多语言id
              nameObj.langId = item.langId;
              //原产地名称
              nameObj.name = '';
              if (item.langId == self.defaultLangObj.langId) {
                nameObj.required = true;
              } else {
                nameObj.required = false;
              }
              var _iterator7 = _createForOfIteratorHelper(dataNameList),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var item2 = _step7.value;
                  if (item.langId == item2.langId) {
                    nameObj.name = item2.name;
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              specNameDetail.push(nameObj);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          self.specNameDetailData.specNameDetail = specNameDetail;
          self.visibleSpecName = true;
        }
      });
    },
    /* 规格值编辑按钮 */editSpecValueBtn: function editSpecValueBtn(id) {
      var _this7 = this;
      this.currentSpecValueId = id;
      getSpecValueDetail(id).then(function (response) {
        if (response.data.code == 200) {
          var dataNameList = response.data.data;
          var newNameList = _.cloneDeep(_this7.initialNameList);
          var _iterator8 = _createForOfIteratorHelper(newNameList),
            _step8;
          try {
            var _loop = function _loop() {
              var initial = _step8.value;
              var findObj = _.find(dataNameList, function (o) {
                return o.langId == initial.langId;
              });
              if (findObj) {
                initial.langId = findObj.langId;
                initial.name = findObj.name;
              }
            };
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          _this7.specValueData.nameList = _.cloneDeep(newNameList);
          _this7.dialogStatus = 'update';
          _this7.visibleSpecValue = true;
        }
      });
    },
    // 删除规格值
    deleteSpecValue: function deleteSpecValue(id) {
      var _this8 = this;
      _deleteSpecValue(id).then(function (response) {
        if (response.data.code == 200) {
          _this8.$message.success(_this8.$t('public.deleteSuccessfully'));
          _this8.getSpecList();
          _this8.getSpecDetailList();
        }
      });
    },
    /* 添加按钮 */addSpecValueModal: function addSpecValueModal(specId) {
      this.currentSpecNameId = specId;
      this.dialogStatus = 'create';
      this.resetspecValueData();
      this.visibleSpecValue = true;
    },
    // 规格名弹窗取消
    cancelPpdateSpecName: function cancelPpdateSpecName() {
      this.visibleSpecName = false;
    },
    // 规格名弹窗更新
    updateSpecName: function updateSpecName() {
      var _this9 = this;
      this.$refs.specNameForm.validate(function (valid) {
        if (valid) {
          var param = {
            id: _this9.currentSpecNameId,
            list: _this9.specNameDetailData.specNameDetail
          };
          _this9.updateLoadingN = true;
          _updateSpecName(param).then(function (response) {
            if (response.data.code == 200) {
              _this9.$message.success(_this9.$t('public.updateSuccessfully'));
              _this9.visibleSpecName = false;
              _this9.getSpecList();
              _this9.getSpecDetailList();
            }
            _this9.updateLoadingN = false;
          }).finally(function () {
            _this9.updateLoadingN = false;
          });
        }
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visibleSpecValue = false;
      this.resetspecValueData();
    },
    //初始规格值化弹窗
    resetspecValueData: function resetspecValueData() {
      this.specValueData = {
        id: '',
        nameList: _.cloneDeep(this.initialNameList)
      };
    },
    /* 确定添加 */addSpecValue: function addSpecValue() {
      var _this0 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this0.addLoadingV = true;
          var param = {
            id: _this0.currentSpecNameId,
            langDataList: _this0.specValueData.nameList
          };
          _addSpecValue(param).then(function (response) {
            if (response.data.code == 200) {
              _this0.$message.success(_this0.$t('public.addSuccessfully'));
              _this0.visibleSpecValue = false;
              _this0.getSpecList();
              _this0.getSpecDetailList();
            }
            _this0.addLoadingV = false;
          }).finally(function () {
            _this0.addLoadingV = false;
          });
        }
      });
    },
    /* 确定规格值更新 */updateSpecValue: function updateSpecValue() {
      var _this1 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var param = {
            id: _this1.currentSpecValueId,
            list: _this1.specValueData.nameList
          };
          _this1.updateLoadingV = true;
          _updateSpecValue(param).then(function (response) {
            if (response.data.code == 200) {
              _this1.$message.success(_this1.$t('public.updateSuccessfully'));
              _this1.visibleSpecValue = false;
              _this1.getSpecList();
              _this1.getSpecDetailList();
            }
            _this1.updateLoadingV = false;
          }).finally(function () {
            _this1.updateLoadingV = false;
          });
        }
      });
    },
    //获取规格明细列表
    getSpecDetailList: function getSpecDetailList() {
      var _this10 = this;
      var self = this;
      self.isTableLoading = true;
      _getSpecDetailList(self.productId).then(function (response) {
        if (response.data.code == 200) {
          var specDetailList = response.data.data;
          var _iterator9 = _createForOfIteratorHelper(specDetailList),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var item = _step9.value;
              // if (item.productChannelid == 0) {
              // 	item.productChannelid = undefined;
              // }
              if (item.caseOrItem && item.caseOrItem.length > 2) {
                item.caseOrItem = item.caseOrItem.split(',');
              } else {
                item.caseOrItem = _toConsumableArray(item.caseOrItem);
              }
              if (!item.supplierName) {
                item.supplierName = undefined;
              }
              if (item.productPrice == 0) {
                item.productPrice = '';
              }
              if (item.productBrandid == 0) {
                item.productBrandid = undefined;
              }
              if (item.productSourceareaid == 0) {
                item.productSourceareaid = undefined;
              }
              if (item.productNo) {
                _this10.noEditproductNo = true;
              } else {
                _this10.noEditproductNo = false;
              }
              // item.caseOrItem = []
              // item.productChannelidErr = false;
              // item.productPriceErr = false;
              item.productStocknumErr = false;
              // item.productNoErr = false;
              // item.productSkunoErr = false;
              // item.transportmoduleid = item.transportmoduleid == 0 ? undefined : item.transportmoduleid
              item.productNoError = false;
              item.caseOrItemError = false;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          self.specDetailList = specDetailList;
          // this.erpCreateTime = specDetailList.erpCreateTime
          self.initSpecDetailList = _.cloneDeep(specDetailList);
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    //保存无规格商品
    save: function save() {
      var _this11 = this;
      var self = this;
      var param = _.cloneDeep(self.formData);
      // param.disabledPay = param.disabledPay.toString();
      param.id = self.productId;
      if (param.caseOrItem.length > 0) {
        param.caseOrItem = param.caseOrItem.sort();
        param.caseOrItem = param.caseOrItem.join(',');
      }
      // param.bundlingNote = JSON.stringify(param.bundlingNote)
      console.log(param);
      self.$refs.formData.validate(function (valid) {
        console.log(valid);
        if (valid) {
          self.queryLoading = true;
          param.erpCreateTime = _this11.erpCreateTime;
          updatePriceAndStock(param).then(function (response) {
            if (response.data.code == 200) {
              self.$message.success(self.$t('public.saveSuccessfully'));
              self.init(1);
            } else {
              self.queryLoading = false;
              console.log(123213);
            }
          }).finally(function () {
            self.queryLoading = false;
          });
        }
      });
    },
    //保存有规格商品
    save2: function save2() {
      var self = this;
      if (self.specDetailList.length == 0) {
        self.$message.error(self.$t('productDetail.specsValueNull'));
        return;
      }
      var param = _.cloneDeep(self.form2Data);
      param.bundlingNote = '';
      param.disabledPay = param.disabledPay.toString();
      param.id = self.productId;
      // param.bundlingNote = JSON.stringify(param.bundlingNote)
      console.log(param, 'params...........');
      self.$refs.formData2.validate(function (valid) {
        if (valid) {
          self.save2Loading = true;
          updatePriceAndStock(param).then(function (response) {
            if (response.data.code == 200) {
              self.save2Loading = false;
              self.initForm2Data = _.cloneDeep(self.form2Data);
              self.$message.success(self.$t('public.saveSuccessfully'));
            } else {
              self.save2Loading = false;
            }
          }).finally(function () {
            self.save2Loading = false;
          });
        }
      });
    },
    //规格名/值错误提示状态位修改
    validate: function validate(text, record) {
      if (text == '') {
        record.isRequired = true;
      } else {
        record.isRequired = false;
      }
    },
    ///批量修改规格明细表
    showModal: function showModal(data) {
      var self = this;
      self.editproductSpecsObj = _.cloneDeep(self.initeditproductSpecsObj);
      self.$nextTick(function () {
        self.visibleBatch = true;
        self.modelInputStaus = data;
      });
    },
    //保存规格明细列表
    saveSpecsList: function saveSpecsList() {
      var _this12 = this;
      var self = this;
      if (self.specDetailList.length == 0) {
        self.$message.error(self.$t('productDetail.specsValueNull'));
        return;
      }
      var detailListParam = _.cloneDeep(self.specDetailList);
      var _iterator0 = _createForOfIteratorHelper(self.specDetailList),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var item = _step0.value;
          console.log(_typeof(item.productStocknum), item.productStocknum, '11111111');
          console.log(item.productStocknum == null, '2222');
          if (item.productNo == '' || item.productNo == null || item.productNo == undefined) {
            item.productNoError = true;
            return;
          } else if (item.caseOrItem == '' || item.caseOrItem == undefined || item.caseOrItem == null) {
            item.caseOrItemError = true;
            return;
          } else if (item.productStocknum === '' || item.productStocknum == null || item.productStocknum == undefined) {
            item.productStocknumErr = true;
            return;
          }
          // else if (item.productChannelid == undefined || !item.productChannelid) {
          // 	if(self.deliveryChannel == 1 || this.deliveryChannel == null || this.deliveryChannel == undefined) {
          // 		item.productChannelidErr = true;
          // 		return;
          // 	}
          // }
          // else if (item.productSkuno == '' || item.productSkuno == null || item.productSkuno == undefined) {
          // 	item.productSkunoErr = true;
          // 	return;
          // } else if (item.productStocknum === '' || item.productStocknum === null || item.productStocknum === undefined) {
          // 	item.productStocknumErr = true;
          // 	return;
          // } else if (item.productPrice === '' || item.productPrice === null || item.productPrice === undefined || item.productPrice === 0) {
          // 	item.productPriceErr = true;
          // 	return;
          // } else if (item.productChannelid == undefined || !item.productChannelid) {
          // 	if(self.deliveryChannel == 1 || this.deliveryChannel == null || this.deliveryChannel == undefined) {
          // 		item.productChannelidErr = true;
          // 		return;
          // 	}
          // }
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      var _iterator1 = _createForOfIteratorHelper(detailListParam),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var _item = _step1.value;
          if (_item.caseOrItem.length > 0) {
            _item.caseOrItem = _item.caseOrItem.sort();
            _item.caseOrItem = _item.caseOrItem.join(',');
          }
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      var param = {
        productId: self.productId,
        specDetailInfo: detailListParam
      };
      self.queryLoading2 = true;
      saveSpecDetailList(param).then(function (response) {
        console.log(456);
        if (response.data.code == 200) {
          self.initSpecDetailList = _.cloneDeep(self.specDetailList);
          self.$message.success(self.$t('public.saveSuccessfully'));
          _this12.init(1);
        }
      }).finally(function () {
        self.queryLoading2 = false;
      });
    },
    //批量修改提交
    handleOk: function handleOk(e) {
      var self = this;
      self.confirmLoading = true;
      // setTimeout(() => {
      var productSpecsList = self.specDetailList;
      console.log(self.editproductSpecsObj.productBarcode);
      var _iterator10 = _createForOfIteratorHelper(productSpecsList),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var item = _step10.value;
          if (self.modelInputStaus == 'productBarcode') {
            item.productBarcode = self.editproductSpecsObj.productBarcode;
          } else if (self.modelInputStaus == 'productStocknum') {
            if (self.editproductSpecsObj.productStocknum) {
              item.productStocknum = self.editproductSpecsObj.productStocknum;
              item.productStocknumErr = false;
            }
          } else if (self.modelInputStaus == 'productPrice') {
            if (self.editproductSpecsObj.productPrice) {
              item.productPrice = self.editproductSpecsObj.productPrice;
              item.productPriceErr = false;
            }
          } else if (self.modelInputStaus == 'productChannelid') {
            if (self.editproductSpecsObj.productChannelid) {
              item.productChannelid = parseInt(self.editproductSpecsObj.productChannelid);
              item.productChannelidErr = false;
            }
          } else if (self.modelInputStaus == 'stockSyn') {
            item.stockSyn = parseInt(self.editproductSpecsObj.stockSyn);
          } else if (self.modelInputStaus == 'productSkuno') {
            if (self.editproductSpecsObj.productSkuno) {
              item.productSkunoErr = false;
              item.productSkuno = self.editproductSpecsObj.productSkuno;
            }
          } else if (self.modelInputStaus == 'productLong') {
            item.productLong = self.editproductSpecsObj.productLong;
          } else if (self.modelInputStaus == 'productWidth') {
            item.productWidth = self.editproductSpecsObj.productWidth;
          } else if (self.modelInputStaus == 'productHeight') {
            item.productHeight = self.editproductSpecsObj.productHeight;
          } else if (self.modelInputStaus == 'productWeight') {
            item.productWeight = self.editproductSpecsObj.productWeight;
          } else if (self.modelInputStaus == 'freightMode') {
            item.transportmoduleid = self.editproductSpecsObj.freightMode;
          }

          // this.$set(item,'productBarcode',self.editproductSpecsObj.productBarcode)
          console.log(item);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      self.specDetailList = productSpecsList;
      console.log('1', self.productSpecsList);
      // self.refreshList();
      // self.$forceUpdate();
      console.log('2', self.productSpecsList);
      self.visibleBatch = false;
      self.confirmLoading = false;
      // }, 2000);
    },
    //批量修改取消
    handleCancel: function handleCancel(e) {
      console.log('Clicked cancel button');
      this.visibleBatch = false;
    },
    //规格明细表输入项值变化时执行
    onCellChange: function onCellChange(record, slotName, obj) {
      console.log('change');
      record.productNoError = false;
      if (record) {
        record[slotName] = obj.value;
        console.log(record[slotName]);
        console.log(this.specDetailList);
        record[slotName + 'Err'] = obj.errStatus;
      }
      if (slotName == 'productNo') {
        console.log(obj, 'obj');
        this.inputDebounce(record);
      }
    },
    changeDistribution: function changeDistribution() {
      var self = this;
      if (self.specFlag == 2) {
        if (self.formData.distribution == 1) {
          self.formData.transportFirstId = undefined;
          self.formData.transportSecondIdList = [];
        }
      } else {
        if (self.form2Data.distribution == 1) {
          self.form2Data.transportFirstId = undefined;
          self.form2Data.transportSecondIdList = [];
        }
      }
    },
    check: function check() {
      console.log(1213123232123);
      if (this.specFlag == 2) {
        if (JSON.stringify(this.formData) != JSON.stringify(this.initFormData)) {
          return false;
        } else {
          return true;
        }
      } else {
        console.log(1213123232123);
        if (JSON.stringify(this.form2Data) != JSON.stringify(this.initForm2Data) || JSON.stringify(this.specDetailList) != JSON.stringify(this.initSpecDetailList)) {
          return false;
        } else {
          return true;
        }
      }
    },
    gotoVisible: function gotoVisible(row) {
      console.log(row, 'row');
      var routeData = this.$router.resolve({
        path: '/goodsVisible/editGoodsVisible',
        query: {
          name: row.productNo,
          id: row.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    // 商品编号输入实时处理：格式化（全角转半角+过滤+大写）后回写，再触发查重
    onProductNoInput: function onProductNoInput() {
      // v-model 已把原始输入写入 formData.productNo，这里格式化后覆盖显示
      this.formData.productNo = this.formatProductNo(this.formData.productNo);
      // 传入 formData 作为 info，兼容 inputDebounce 内对 info 的使用（如 info.erpCreateTime）
      this.inputDebounce(this.formData);
    },
    // 全角转半角 + 仅保留半角字母数字 + 转大写
    formatProductNo: function formatProductNo(str) {
      if (!str) return '';
      // 1. 全角字符（U+FF01~U+FF5E）整体转为半角（U+0021~U+007E），如全角字母数字ＡＢ１２ → AB12
      var result = String(str).replace(/[\uFF01-\uFF5E]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
      });
      // 2. 仅保留半角字母和数字，其余（中文、符号、空格、全角空格等）删除
      result = result.replace(/[^a-zA-Z0-9]/g, '');
      // 3. 统一转大写
      return result.toUpperCase();
    },
    inputDebounce: function inputDebounce(info) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, nowTime;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this13.errContent = '';
              params = {
                productNos: _this13.specFlag != 2 ? info['productNo'] : _this13.formData.productNo
              };
              _context3.n = 1;
              return getContentfromProductNO(params);
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                nowTime = moment().format("YYYY-MM-DD HH:mm:ss");
                _this13.erpCreateTime = res.data.data.length > 0 ? res.data.data[0].erpCreateTime : nowTime;
                info.erpCreateTime = _this13.erpCreateTime;
                if (_this13.specFlag == 2) {
                  _this13.formData.supplierName = res.data.data.length > 0 ? res.data.data[0].supplierName : '';
                  _this13.formData.supplierCode = res.data.data.length > 0 ? res.data.data[0].supplierCode : '';
                  _this13.formData.productBelong = res.data.data.length > 0 ? res.data.data[0].productBelong : 1;
                  if (res.data.data[0] && res.data.data[0].firstTime) {
                    _this13.formData.firstTime = res.data.data[0].firstTime;
                  }
                  if (res.data.data[0] && res.data.data[0].caseQuantity) {
                    _this13.formData.caseQuantity = res.data.data[0].caseQuantity;
                  }
                  // this.formData.transportFirstId = this.formData.transportFirstId ? this.formData.transportFirstId : (res.data.data[0].transportId ? res.data.data[0].transportId : undefined)
                } else {
                  info.supplierName = res.data.data.length > 0 ? res.data.data[0].supplierName : '';
                  info.supplierCode = res.data.data.length > 0 ? res.data.data[0].supplierCode : '';
                  info.productBelong = res.data.data.length > 0 ? res.data.data[0].productBelong : 1;
                  if (res.data.data[0] && res.data.data[0].firstTime) {
                    info.firstTime = res.data.data[0].firstTime;
                  }
                  if (res.data.data[0] && res.data.data[0].caseQuantity) {
                    info.caseQuantity = res.data.data[0].caseQuantity;
                  }

                  // this.form2Data.transportFirstId = this.form2Data.transportFirstId ? this.form2Data.transportFirstId : (res.data.data[0].transportId ? res.data.data[0].transportId : undefined)
                  console.log(info, 'info');
                  // if(info.productNo && !info.supplierName) {
                  // 	info.productNoError = true
                  // 	this.errContent = this.$t('newProducDetail.prductNoerror')
                  // }
                }
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    } // async checkProductNo(rule, value,callback) {
    // 	if(this.specFlag == 2 && !this.formData.supplierName) {
    // 		callback(new Error(this.$t('newProducDetail.prductNoerror')))
    // 	} else {
    // 		callback()
    // 	}	
    // }
  }
};